export default __webpack_public_path__ + "static/media/eth-purple.d0a812ff.svg";